const aclMixin = {
  methods: {
    _is (role) {
      try {
        let acl = JSON.parse(this.$store.state.acl)
        if (acl) {
          return acl.hasOwnProperty(role)
        }
        return false
      } catch (e) {
        return false
      }
    },

    _can (permission) {
      try {
        let acl = JSON.parse(this.$store.state.acl)
        if (acl) {
          for (let r in acl) {
            if (acl.hasOwnProperty(r) && Array.isArray(acl[r])) {
              for (let p in acl[r]) {
                if (acl[r].hasOwnProperty(p) && acl[r][p] === permission) {
                  return true
                }
              }
            }
          }
        }
        return false
      } catch (e) {
        return false
      }
    },

    myAgencies () {
      return JSON.parse(this.$store.state.accountAgencies) || []
    }
  }
}

export default aclMixin
